import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-uncurry-this.js";
import { f as e } from "../internals/fails.js";
var n = e(function () {
    return 120 !== new Date(16e11).getYear();
  }),
  a = r(Date.prototype.getFullYear);
t({
  target: "Date",
  proto: !0,
  forced: n
}, {
  getYear: function getYear() {
    return a(this) - 1900;
  }
});